var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25a.75.75 0 000 1.5v-1.5zm16.5 1.5a.75.75 0 000-1.5v1.5zm-7.5-9a.75.75 0 00-1.5 0h1.5zm-1.5 16.5a.75.75 0 001.5 0h-1.5zm-7.5-7.5h16.5v-1.5H3.75v1.5zm7.5-9v16.5h1.5V3.75h-1.5z",
    fill: "#90AEAA"
  })));
}
export default SvgIconPlus;